import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const NotificationCardWrapper = styled.div`
	padding: 12px;
	border-radius: 4px;
	box-shadow: 0 0 4px rgba(51, 51, 51, 0.25);

	display: flex;
	flex-direction: column;
	gap: 8px;

	.header {
		color: ${colors.greyscale.dark_grey};
		font-size: 11px;

		button {
			color: inherit;
		}

		.from {
			display: flex;
			gap: 8px;
			align-items: center;

			img {
				width: 20px;
				height: 20px;
			}
		}
	}

	.message {
		font-size: 12px;
		font-weight: 400;
		color: ${colors.greyscale.black};

		a {
			color: ${colors.mainColors.blueberry};
		}
	}
`;
